module.exports = __webpack_public_path__ + "static/media/story-20.eed31b3a.jpg";